module.exports = __webpack_public_path__ + "static/media/64.482da079.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/64.jpg
// module id = 624
// module chunks = 0